import m from "../../geodata/es2015/singaporeHigh";
window.am4geodata_singaporeHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/singaporeHigh.js
// module id = null
// module chunks = 